module.exports = __webpack_public_path__ + "static/media/UK.540753ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backs/UK.jpg
// module id = 987
// module chunks = 0